import type { LinksFunction } from "react-router";
import parse from 'html-react-parser';
import { Container } from "react-bootstrap";
import BreadcrumbLinks from "./bread-crumb-links";
import styles from './bread-crumb.css?url';
import type { Tag } from '~/models/tag';

interface Props {
    title: string;
    text: string;
    links?: Tag[] | null;
}

export default function BreadcrumbSection({ title, text, links }: Props) {
    return (
        <>
            <div className="breadcrumbs" data-aos="fade-in">
                <Container>
                    <h1>{parse(title)}</h1>
                    <p className='hideText' >{parse(text)}</p>
                    {links && <BreadcrumbLinks breadcrumbs={links} />}
                </Container>
            </div>
        </>
    );
}

export const links: LinksFunction = () => [
    { rel: "stylesheet", href: styles },
];